import type { ReactNode } from "react"
import brandMark from "~/images/brand/huashu-mark.png"

// The shumiaoapp icon on the site's primary plate. It stays a filled tile: the
// artwork's white discs and translucent trunk have no contrast of their own, so
// knocked out onto a pale surface only the flowers survive.
function BrandMark() {
  return (
    <img
      aria-hidden
      alt=""
      className="size-12 shrink-0 rounded-2xl"
      src={brandMark}
    />
  )
}

type AuthShellProps = {
  children: ReactNode
  subtitle: string
  title: string
}

export function AuthShell({ children, subtitle, title }: AuthShellProps) {
  return (
    <div className="app-auth relative flex min-h-dvh flex-col overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-24 top-10 size-72 rounded-full bg-primary-container/50 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 bottom-0 size-80 rounded-full bg-tertiary-container/45 blur-3xl"
      />

      <div className="relative flex flex-1 flex-col lg:flex-row">
        <section className="flex flex-col justify-center px-6 py-10 lg:w-[42%] lg:px-12 lg:py-16 xl:px-16">
          <div className="mx-auto flex w-full max-w-md flex-col gap-5 lg:mx-0">
            <div className="flex items-center gap-3">
              <BrandMark />
              <div>
                <p className="text-primary-ink text-lg font-semibold leading-tight">
                  花树
                </p>
                <p className="text-on-surface-variant text-sm">成长记录</p>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <h1 className="text-on-surface text-3xl font-semibold leading-tight tracking-tight lg:text-4xl">
                记录成长，留住时光
              </h1>
              <p className="text-on-surface-variant max-w-sm text-base leading-relaxed">
                为家长准备的温柔记录本。记下身高体重与每一个成长瞬间，轻松回顾孩子的变化。
              </p>
            </div>
          </div>
        </section>

        <main className="flex flex-1 items-center justify-center px-4 pb-10 pt-2 lg:px-10 lg:py-16">
          <div className="w-full max-w-md">
            <header className="mb-5 lg:hidden">
              <p className="text-on-surface text-xl font-semibold">{title}</p>
              <p className="text-on-surface-variant mt-1 text-sm">{subtitle}</p>
            </header>

            <div className="cloud-shadow bg-surface/90 rounded-3xl border border-white/70 p-1 backdrop-blur-sm">
              <div className="hidden px-6 pt-6 lg:block">
                <p className="text-foreground text-xl font-semibold">{title}</p>
                <p className="text-muted mt-1 text-sm">{subtitle}</p>
              </div>
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
